import { PropsWithoutRef } from 'react'

import Icon from '@ant-design/icons'
import { IconBaseProps } from '@ant-design/icons/lib/components/Icon'

import { RocketSvg } from './RocketSvg'

export const EaRocketIcon = (props: PropsWithoutRef<IconBaseProps>) => (
  <Icon component={RocketSvg} {...props} />
)
